export default __webpack_public_path__ + "static/media/sum.0c195d3e.jpg";